import React from "react";
import { Link, useLocation } from "react-router-dom";
import "./OrderNowSticky.css";
import { FaUtensils } from "react-icons/fa";

const OrderNowSticky = () => {
  const location = useLocation();

  // Do not render on /view-our-menu
  if (location.pathname === "/view-our-menu") return null;

  return (
    <div className="order-now-sticky">
      <Link to="/view-our-menu" className="order-now-button">
        <FaUtensils className="order-now-icon" />
        <span>ORDER NOW</span>
      </Link>
    </div>
  );
};

export default OrderNowSticky;
